module.exports = __webpack_public_path__ + "static/media/facebook-rond.b1b65b44.png";